import React from 'react';

function ListenerIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 150 150">
      <rect width="150" height="150" fill="#97E0CE" rx="75" />
      <circle cx="75.8" cy="59.6" r="19.8" fill="#185941" />
      <path
        fill="#185941"
        d="M75 80.5c-14.8 0-27.4 11.7-31.1 27.7-1.3 5.4 3.3 10 8.9 10h44.6c5.5 0 10-4.6 8.8-10-3.7-16-16.2-27.7-31.1-27.7z"
      />
      <path
        stroke="#185941"
        strokeWidth="5"
        d="M96.7 71.8V53c0-11.4-9.3-20.8-20.8-20.8v0A20.8 20.8 0 0055.1 53v18.8"
      />
      <path
        fill="#fff"
        d="M46.1 68.3c-.8-4.4 2.4-8.6 7.2-9.4 4.7-.7 4.7 3 5.5 7.3.9 4.4 2.3 7.9-2.5 8.7-4.8.7-9.3-2.2-10.2-6.6z"
      />
      <rect
        width="5.9"
        height="20.5"
        fill="#97E0CE"
        rx="2.9"
        transform="matrix(-.98716 .15975 -.18867 -.98204 61.3 76.2)"
      />
      <path
        fill="#fff"
        d="M105.8 68.3c-.9 4.4-5.4 7.3-10.2 6.6-4.8-.8-3.4-4.3-2.6-8.7.9-4.4.8-8 5.6-7.3 4.8.8 8 5 7.2 9.4z"
      />
      <rect
        width="5.9"
        height="20.5"
        fill="#97E0CE"
        rx="2.9"
        transform="matrix(-.98716 -.15975 .18867 -.98204 96.3 77.2)"
      />
    </svg>
  );
}

function MicIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 150 150">
      <path fill="#97E0CE" d="M0 75a75 75 0 11150 0A75 75 0 010 75z" />
      <g clipPath="url(#mic-icon-clip0)">
        <path fill="#185941" d="M78 94.6h-7v24.6h7V94.6z" />
        <path
          fill="#fff"
          d="M98 116.4c0-2-1.6-3.6-3.5-3.6h-40c-2 0-3.5 1.6-3.5 3.6s1.6 3.6 3.5 3.6h40c2 0 3.5-1.6 3.5-3.6z"
        />
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M51.7 73c2.1 0 3.8 1.7 3.8 3.8 0 8.4 8 15.9 18.7 15.9h.6c10.7 0 18.7-7.5 18.7-16 0-2 1.7-3.7 3.8-3.7 2.1 0 3.8 1.7 3.8 3.8C101.1 90 89 100 74.8 100h-.6c-14.1 0-26.3-10-26.3-23.3 0-2 1.7-3.8 3.8-3.8z"
          clipRule="evenodd"
        />
        <path
          fill="#185941"
          d="M74.5 27.9c-8.7 0-15.8 6.3-15.8 14v32.5c0 7.7 7 14 15.8 14 8.7 0 15.8-6.3 15.8-14V42c0-7.7-7-14-15.8-14z"
        />
      </g>
      <path
        fill="#fff"
        d="M73.3 70.3v-2.7a8.3 8.3 0 01-5.6-3.2l2-2c1 1.3 2.2 2.1 3.6 2.4v-5c-1.6-.3-3-.8-3.8-1.7-1-.9-1.4-2-1.4-3.5 0-1.3.5-2.4 1.5-3.3 1-1 2.2-1.4 3.7-1.6v-2.6h2.4v2.7c2 .3 3.6 1.2 5 2.6l-2 2.2a6 6 0 00-3-2v4.6c2 .3 3.3 1 4.2 1.9 1 1 1.4 2.1 1.4 3.5s-.5 2.6-1.5 3.5c-1 .9-2.3 1.4-4 1.6v2.6h-2.5zm5-7.6c0-1.3-.8-2-2.6-2.5V65c.9-.1 1.5-.4 2-.8.4-.4.6-.9.6-1.5zm-7.2-8.1c0 1.1.7 1.9 2.2 2.2v-4.4c-.7.1-1.3.4-1.6.8-.4.4-.6.9-.6 1.4z"
      />
      <defs>
        <clipPath id="mic-icon-clip0">
          <path
            fill="#fff"
            d="M0 0h65.9v93H0z"
            transform="translate(41.5 27)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

function ClockIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 150 150">
      <rect width="150" height="150" fill="#97E0CE" rx="75" />
      <rect
        width="97.6"
        height="97.6"
        x="26.2"
        y="26.2"
        stroke="#185941"
        strokeWidth="6"
        rx="48.8"
      />
      <rect
        width="78.1"
        height="78.1"
        x="35.9"
        y="35.9"
        stroke="#fff"
        strokeDasharray="1 20"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="4"
        rx="39.1"
      />
      <path
        stroke="#185941"
        strokeLinecap="round"
        strokeWidth="6"
        d="M76.5 48.8v28.5M75 78H54.8"
      />
      <circle cx="104.5" cy="108.9" r="19.6" fill="#fff" />
      <path
        fill="#185941"
        fillRule="evenodd"
        d="M105 103.4a8 8 0 00-3.3-2.1c-1.6-.6-3.6-.6-5.2.9-2.4 2.1-2.3 5.5-.7 8.7 1.6 3.2 4.9 6.2 9 7.8h.4c4-1.6 7.1-4.6 8.8-7.8 1.6-3.2 1.8-6.6-.5-8.8-1.6-1.4-3.6-1.4-5.2-.8a8.2 8.2 0 00-3.3 2.1z"
        clipRule="evenodd"
      />
    </svg>
  );
}

function MixerIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 150 150">
      <rect width="150" height="150" fill="#97E0CE" rx="75" />
      <rect width="6" height="75" x="33" y="37.5" fill="#185941" rx="3" />
      <rect width="6.8" height="75" x="58.5" y="37.5" fill="#185941" rx="3.4" />
      <rect width="6.8" height="75" x="84" y="37.5" fill="#185941" rx="3.4" />
      <rect width="6" height="75" x="110.3" y="37.5" fill="#185941" rx="3" />
      <rect
        width="6"
        height="21"
        x="123.8"
        y="49.5"
        fill="#fff"
        rx="3"
        transform="rotate(90 123.8 49.5)"
      />
      <rect
        width="6"
        height="21"
        x="98.3"
        y="78.8"
        fill="#fff"
        rx="3"
        transform="rotate(90 98.3 78.8)"
      />
      <rect
        width="6"
        height="21"
        x="72.8"
        y="66"
        fill="#fff"
        rx="3"
        transform="rotate(90 72.8 66)"
      />
      <rect
        width="6"
        height="21"
        x="46.5"
        y="93.8"
        fill="#fff"
        rx="3"
        transform="rotate(90 46.5 93.8)"
      />
    </svg>
  );
}

export { MixerIcon, MicIcon, ListenerIcon, ClockIcon };
